import { useState } from "react";
import { Check, LogOut, Wallet } from "lucide-react";

import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Separator } from "@/components/ui/separator";
import { MemberAvatar } from "@/components/member-avatar";

export function SettingsPage() {
  const { household, members, user, signOut, refresh } = useAuth();
  const [name, setName] = useState(household?.name ?? "");
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  const save = async () => {
    if (!name.trim() || name.trim() === household?.name) return;
    setSaving(true);
    try {
      await api.patch("/api/household", { name: name.trim() });
      await refresh();
      setSaved(true);
      setTimeout(() => setSaved(false), 1500);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="mx-auto max-w-xl space-y-5">
      {/* Household */}
      <Card>
        <CardHeader>
          <CardTitle className="text-base">Household</CardTitle>
        </CardHeader>
        <CardContent className="space-y-3">
          <label className="block space-y-1">
            <span className="text-xs font-medium text-muted-foreground">Name</span>
            <div className="flex gap-2">
              <Input value={name} onChange={(e) => setName(e.target.value)} />
              <Button onClick={save} disabled={saving || !name.trim() || name.trim() === household?.name}>
                {saved ? <Check /> : "Save"}
              </Button>
            </div>
          </label>
        </CardContent>
      </Card>

      {/* Members */}
      <Card>
        <CardHeader>
          <CardTitle className="text-base">Members</CardTitle>
        </CardHeader>
        <CardContent className="space-y-1">
          {members.map((m) => (
            <div key={m.id} className="flex items-center gap-3 py-2">
              <MemberAvatar member={m} />
              <div className="min-w-0 flex-1">
                <div className="font-medium">
                  {m.name}
                  {m.id === user?.id && <span className="ml-2 text-xs text-muted-foreground">(you)</span>}
                </div>
              </div>
            </div>
          ))}
        </CardContent>
      </Card>

      {/* Coming soon */}
      <Card className="border-dashed">
        <CardContent className="flex items-center gap-3 p-4 text-muted-foreground">
          <Wallet className="size-5" />
          <div className="flex-1 text-sm">
            <span className="font-medium text-foreground">Finance &amp; budgets</span> — income, expenses and monthly
            tracking are coming next.
          </div>
        </CardContent>
      </Card>

      <Separator />

      <Button variant="outline" className="w-full gap-2 text-destructive" onClick={signOut}>
        <LogOut /> Sign out
      </Button>
    </div>
  );
}
